import { SurveyResponseTypes } from './response-types';
import { SurveyModel } from '../survey/survey-model';
import { SurveySummaryModel } from '../survey/survey-summary-model';

export interface ChartClickResponse {
  responseType: SurveyResponseTypes;
  selectedSurvey: SurveySummaryModel | SurveyModel;
}
